import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"liquor"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M19.5 2.5L21.5 4.5L17 9L17 13L8.70712 21.2929C8.3166 21.6834 7.68343 21.6834 7.29291 21.2929L2.70711 16.7071C2.31658 16.3166 2.31658 15.6834 2.70711 15.2929L11 6.99999L15 7L19.5 2.5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M8.99998 9L15 15L11 19L5 13L8.99998 9Z"}},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M19.4999 2.5L21.4999 4.5L16.9999 9L16.9999 13L8.70697 21.2929C8.31644 21.6834 7.68328 21.6834 7.29276 21.2929L2.70696 16.7071C2.31643 16.3166 2.31643 15.6834 2.70696 15.2929L10.9999 6.99999L14.9999 7L19.4999 2.5Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M8.99982 9L14.9998 15L10.9998 19L4.99985 13L8.99982 9Z","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9.99805 13.998H10.002V14.002H9.99805V13.998Z","strokeWidth":"props.strokeWidth"}}]}]};

const Liquor = Vue.extend<IconProps>({
  name: 'LiquorIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'liquor',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Liquor;
